import classNames from 'classnames'

import { HTMLText } from '@crossfit/ui'
import style from './style.module.css'

type Props = {
  questionText: string
  className?: string
}

function FAQAccordionDetails({ questionText, className }: Props) {
  return (
    <HTMLText className={classNames(style.question, className && className)}>
      {questionText}
    </HTMLText>
  )
}

export default FAQAccordionDetails
